import { getAxiosClientWithToken } from './index';
import { getAxiosClientWithTokenV2 } from './indexV2';
import { DuplicateScheduleParams, ListScheduleRequest, PriceSegmentScheduleParams } from '../types/schedule';

export const getListScheduleAPI = (params?: ListScheduleRequest) => {
  return getAxiosClientWithToken().get('/schedule', { params });
};

export const getDetailScheduleAPI = (id: number) => {
  return getAxiosClientWithToken().get(`/schedule/${id}`);
};

export const createScheduleAPI = (params: any) => {
  const restClient = getAxiosClientWithToken();
  return restClient.post('/schedule', params);
};
export const createScheduleAPIV2 = (params: any) => {
  const restClient = getAxiosClientWithTokenV2();
  return restClient.post('/schedule', params);
};

export const updateScheduleAPI = (params: any) => {
  const restClient = getAxiosClientWithToken();
  return restClient.put(`/schedule/${params.id}`, params);
};
export const updateScheduleAPIV2 = (params: any) => {
  const restClient = getAxiosClientWithTokenV2();
  return restClient.put(`/schedule/${params.id}`, params);
};

export const updateStatusScheduleAPI = (params: { id: any; status: boolean }) => {
  const restClient = getAxiosClientWithToken();
  return restClient.put(`/schedule/status/${params.id}`, { status: params?.status ? 0 : 1 });
};

export const duplicateScheduleApi = (params: DuplicateScheduleParams) => {
  const restClient = getAxiosClientWithToken();
  return restClient.post(`/schedule/duplicate/${params?.id}`, params);
};
export const getPriceScheduleSegmentAPI = (params: PriceSegmentScheduleParams) => {
  const restClient = getAxiosClientWithToken();
  return restClient.get(`/price-schedules/segments`, { params });
};
export const getPriceScheduleSegmentByIdAPI = (id: number) => {
  const restClient = getAxiosClientWithToken();
  return restClient.get(`/price-schedules/${id}`);
};
